import { DeliveryPreferenceType } from '@sg/graphql-schema';

// ─── Constants ───────────────────────────────────────────────────────────────────

export enum AddressType {
  HOME = 'home',
  WORK = 'work',
  CUSTOM = 'custom',
}

export const defaultAddressForm = {
  addressType: AddressType.HOME,
  name: '',
  street: '',
  secondaryStreet: '',
  city: '',
  zipCode: '',
  state: '',
  country: '',
  latitude: 0,
  longitude: 0,
  notes: '',
  deliveryPreference: DeliveryPreferenceType.LeaveAtDoor,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type AddressForm = {
  addressType: AddressType;
  name: string;
  street: string;
  secondaryStreet: string;
  city: string;
  zipCode: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  deliveryPreference: DeliveryPreferenceType;
  notes: string;
};

export type AvailableAddress = {
  type: AddressType;
  name: string;
};
